import axios_ from "../utils/axios";
import { useConfig } from "@/api/hook";
import {usePyRequest} from "./usePyConfig"


export default {
  /**
   * 内容发布列表
   * @param {Object} param
   * @property {number} param.page
   * @property {number} param.page_num
   * @property {string} param.start_date  发布开始时间
   * @property {string} param.end_date  结束时间
   * @property {Number} param.publish_status 内容发布状态：1-待发布，2-发布中，3-发布成功，4-发布失败，5-已取消，6-已删除
   * @property {Number} param.platform 平台：1-Meta，2-X，4-instagram，5-TikTok，6-YouTube，配置接口字段：p_c_m_publish_status_config
   * @returns {Promise<DefaultResponseType>}
   */
  getPublisherList(param) {
    return axios_("get", `api/pandagpt/v1/platform_content_manage/lists`, param, false, false, true);
  },
  /**
   * 获取当前团队草稿箱列表。
   * @param {Object} param
   * @property {number} param.page 页码
   * @property {number} param.page_num 每页条数
   * @property {string} param.operator 创建人用户 ID
   * @property {number|string} param.platform 平台代号
   * @property {string} param.start_time 创建时间起始
   * @property {string} param.end_time 创建时间截止
   * @property {string} param.text 内容关键词
   * @returns {Promise<DefaultResponseType>}
   */
  getPublisherDraftList(param) {
    // 草稿箱使用独立聚合列表接口，返回按 task_num 聚合后的草稿记录。
    return axios_("get", `api/pandagpt/v1/platform_content_manage/draft_list`, param, false, false, true);
  },
  /**
   * 获取草稿箱创建人下拉列表。
   * draft_operator_list 只返回草稿实际创建人，筛选项不再复用发布日历成员接口。
   * @returns {Promise<DefaultResponseType>}
   */
  publisherDraftOperatorList() {
    return axios_("get", `api/pandagpt/v1/platform_content_manage/draft_operator_list`, {}, false, false, true);
  },
  /**
   * 创建聚合草稿。
   * draft_create 的 page_datas 固定保留 platform=0 的“全部”配置，方便草稿箱按平台聚合回填。
   * @param {{timezone?:string; page_datas:Array<object>}} param
   * @returns {Promise<DefaultResponseType>}
   */
  publisherDraftCreate(param) {
    return axios_("post", `api/pandagpt/v1/platform_content_manage/draft_create`, param, false, false, true);
  },
  /**
   * 更新聚合草稿。
   * draft_update 用 task_num 定位草稿，page_datas 直接传当前页面最终保留的完整配置。
   * @param {{task_num:string|number; timezone?:string; page_datas:Array<object>}} param
   * @returns {Promise<DefaultResponseType>}
   */
  publisherDraftUpdate(param) {
    return axios_("post", `api/pandagpt/v1/platform_content_manage/draft_update`, param, false, false, true);
  },
  /**
   * 获取聚合草稿详情。
   * 草稿箱编辑页按 task_num 读取 platforms 聚合结构，和普通发布详情分开处理。
   * @param {{task_num:string|number}} param
   * @returns {Promise<DefaultResponseType>}
   */
  publisherDraftDetail(param) {
    return axios_("get", `api/pandagpt/v1/platform_content_manage/draft_detail`, param, false, false, true);
  },
  /**
   * 删除聚合草稿。
   * 草稿删除按 task_num 软删整组平台主页记录，不能再按单条内容 id 删除。
   * @param {{task_num:string|number}} param
   * @returns {Promise<DefaultResponseType>}
   */
  publisherDraftDelete(param) {
    return axios_("post", `api/pandagpt/v1/platform_content_manage/draft_delete`, param, false, false, true);
  },
  /**
   * 内容发布文件上传
   * @param {object} param
   * @property {object} file
   * @returns {Promise<DefaultResponseType>}
   */
  publisherUpload(param) {
    return axios_("post", `api/pandagpt/v1/upload_oss/upload_simple`, param, false, true, true);
  },
  /**
   * 内容发布保存/编辑
   * @param {object} param
   * @returns {Promise<DefaultResponseType>}
   */
  publisherStore(param) {
    // api/pandagpt/v1/platform_content_manage/update
    // api/pandagpt/v1/platform_content_manage/create
    return axios_(
      "post",
      `api/pandagpt/v1/platform_content_manage/${param.id ? "update" : "create"}`,
      param,
      false,
      false,
      true
    );
  },
  /**
   * 内容发布 删除
   * @param {object} param
   * @returns {Promise<DefaultResponseType>}
   */
  publisherDelete(param) {
    return axios_("post", `api/pandagpt/v1/platform_content_manage/delete`, param, false, false, true);
  },
  /**
   * 内容发布 详情
   * @param {object} param
   * @returns {Promise<DefaultResponseType>}
   */
  publisherDetail(param) {
    return axios_("get", `api/pandagpt/v1/platform_content_manage/detail`, param, false, false, true);
  },
  /**
   * 获取X平台账号授权链接
   * @param {null} param
   * @returns {Promise<DefaultResponseType>}
   */
  getXAuthUrl(param) {
    return axios_("get", `api/x/get_authorization_url`, param, false, false, true, false);
  },
  /**
   * X平台账号授权回调
   * @param {null} param
   * @returns {Promise<DefaultResponseType>}
   */
  getXAuthCallback(param) {
    return axios_("POST", `api/x/callback`, param, false, false, true, false);
  },

  /**
   * tiktok平台账号授权链接
   * @param {null} param
   * @returns {Promise<DefaultResponseType>}
   */
  getTTAuthUrl(param) {
    return axios_("get", `api/pandagpt/v1/tiktok/authorize`, param, false, false, true, false);
  },
  /**
   * tiktok平台账号授权回调
   * @param {null} param
   * @returns {Promise<DefaultResponseType>}
   */
  getTTAuthCallback(param) {
    return axios_("POST", `api/pandagpt/v1/tiktok/callback`, param, false, false, true, false);
  },
  /**
   * 已授权主页列表
   * @param {null} param
   * @property { number } platform 平台
   * @returns {Promise<DefaultResponseType>}
   * @enum {number} platform 平台：1-Facebook，2-X，4-instagram，5-TikTok，6-YouTube，7-Linkedin，8-Telegram，9-VKontakte
   */
  getAuthUserList(param) {
    return axios_("get", `api/pandagpt/v1/auth_user/auth_user_list`, param, false, false, true, false);
  },
  /**
   * 媒体管理 平台主页
   * @param {null} param
   * @property { number } platform 平台
   * @returns {Promise<DefaultResponseType>}
   */
  getPlatformPages(param) {
    return axios_("get", `api/pandagpt/v1/platform/lists`, param, false, false, true, false);
  },
  /**
   * 授权的主页数量
   * @param {null} param
   * @property { number } platform 平台
   * @returns {Promise<DefaultResponseType>}
   */
  getAuthUserNumber(param) {
    return axios_("get", `api/pandagpt/v1/auth_user/auth_page_total`, param, false, false, true, false);
  },
  /**
   * 获取 oss 视频截帧 url
   * @param {null} param
   * @returns {Promise<DefaultResponseType>}
   */
  getVideoOssSignUrl(param) {
    return axios_("get", `api/pandagpt/v1/upload_oss/get_signed_url`, param, false, false, true, false);
  },
  /**
   * 带签名的视频截帧URL-上传到oss
   * @param {null} param
   * @returns {Promise<DefaultResponseType>}
   */
  uploadSignUrlToOss(param) {
    return axios_("POST", `api/pandagpt/v1/upload_oss/upload_signed_url`, param, false, false, true, false);
  },
  /**
   * 截图后的 base64 替换原图
   * @param {object} param
   * @property {string} param.file_base64 截图 base64
   * @property {string} param.osskey 原图 key
   * @returns {Promise<DefaultResponseType>}
   */
  fetchCropperImage(param) {
    return axios_("POST", `api/pandagpt/v1/upload_oss/upload_base64`, param, false, false, true, false);
  },
  /**
   * 附件验证
   * @param {object} param
   * @returns {Promise<DefaultResponseType>}
   */
  ossValidator(param) {
    return axios_("POST", `api/pandagpt/v1/upload_oss/validate`, param, false, false, true, false);
  },
  /**
   * 同步外部文件上传记录：将 JoinSpark 资源库素材的 oss_key 写入 upload_file_records 表（按 oss_key 去重）。
   * 供内容发布选中资源库素材时，先把外部 oss_key 同步到本服务，再触发附件验证。
   * @param {object} param
   * @property {string} param.oss_key 文件在 OSS 中的存储 key
   * @property {string} param.creative_type 文件类型：image / video
   * @property {string} param.format 文件后缀，如 png、mp4
   * @property {number} param.file_size 文件大小（字节）
   * @property {string} param.name 文件名（不含后缀）
   * @property {number} param.width 宽度（像素）
   * @property {number} param.height 高度（像素）
   * @property {number} param.video_duration 视频时长（秒）
   * @returns {Promise<DefaultResponseType>}
   */
  syncFileRecords(param) {
    return axios_("post", `api/pandagpt/v1/upload_oss/sync_file_records`, param, false, false, true, false);
  },
  /**
   * 文档导入
   * @param {object} param
   * @returns {Promise<DefaultResponseType>}
   */
  contentUploadDoc(param) {
    return axios_("POST", `api/pandagpt/v1/upload_oss/upload_document`, param, false, false, true, false);
  },
  /**
   * 获取油管授权链接
   * @returns {Promise<*|undefined>}
   */
  getYouTubeAuthUrl() {
    return axios_("get", `api/pandagpt/v1/youtube/authorize`, {}, false, false, true, false);
  },

  /**
   * 修改内容的发布状态，支持立即发布、取消发布和重新发布三种操作类型。
   * @param id 任务编号
   * @param {"publish"|"cancel"|"republish"} action publish-立即发布 cancel-取消发布 republish-重新发布
   * @returns {Promise<DefaultResponseType>}
   */
  publication_status(id, action) {
    return axios_(
      ...Object.values(useConfig("GET", "api/pandagpt/v1/platform_content_manage/publication_status", { id, action }))
    );
  },
  /**
   * 查看内容发布贴文操作记录
   * @param {string} id
   * @return {Promise<DefaultResponseType>}
   */
  page_operation_logs(id) {
    return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/platform_content_manage/page_operation", { id })));
  },

  /**
   * 获取VK平台账号授权链接
   * @param {null} param
   * @returns {Promise<DefaultResponseType>}
   */
  getVKAuthUrl(param) {
    return axios_("get", `api/pandagpt/v1/vk/authorize`, param, false, false, true, false);
  },
  /**
   * VK平台账号授权回调
   * @param {null} param
   * @returns {Promise<DefaultResponseType>}
   */
  getVKAuthCallback(param) {
    return axios_("POST", `api/pandagpt/v1/vk/callback`, param, false, false, true, false);
  },
  /**
   * 查看youtube播放列表
   * @param {string} page_id 主页id
   */
  get_youtube_playlist(page_id){
    return axios_(...Object.values(useConfig("GET","api/pandagpt/v1/platform_content_manage/get_youtube_playlist",{page_id})))
  },
  /**
   * 新建youtube播放列表
   * @param {object} params
   * @param {string} params.page_id 主页id
   * @param {string} params.title 标题
   * @param {string} params.description 描述
   * @param {string} params.privacy_status 状态
   */
  create_youtube_playlist(params){
    return axios_(...Object.values(useConfig("POST","api/pandagpt/v1/platform_content_manage/create_youtube_playlist", params)))
  },

  /**
   * 获取youtube国际化语言列表
   * @param {string} page_id 主页id
   */
  get_youtube_i18n_languages(page_id){
    return axios_(...Object.values(useConfig("GET","api/pandagpt/v1/youtube/i18n_languages",{page_id})))
  },


  /**
   * 发起telegram授权
   * @param data
   * @returns {Promise<DefaultResponseType>}
   */
  telegramAuthorize(data){
    return axios_(...Object.values(useConfig("POST","api/pandagpt/v1/telegram/authorize", data)))
  },
  /**
   * 获取telegram登录验证码
   * @param {string} phone_number
   * @returns {Promise<DefaultResponseType>}
   */
  getTelegramPhoneCode(phone_number){
    return axios_(...Object.values(useConfig('POST',"api/pandagpt/v1/telegram/phone_code", {phone_number})))
  },
  /**
   * Telegram 选择频道
   * @param {string} auth_id
   * @param {Array<string>} channel_ids
   * @returns {Promise<DefaultResponseType>}
   */
  telegramSelectChannel(auth_id, channel_ids) {
    return axios_(
      ...Object.values(
        useConfig("POST", "api/pandagpt/v1/telegram/select_channel", {
          auth_id,
          channel_ids,
        })
      )
    );
  },

  /**
   * @typedef PublishedPagesResponseData
   * @property {string} page_id
   * @property {string} page_name
   * @property {string} pic_url
   * @property {number} platform
   */

  /**
   * 获取发布过内容的主页
   * @returns {Promise<DefaultResponseType<PublishedPagesResponseData[]>>}
   */
  get_published_pages() {
    const config = useConfig(
      "GET",
      "api/pandagpt/v1/platform_content_manage/published_pages",
      {},
    )
    return axios_(...Object.values(config))
  },

  // #region ----------------------------- linkedin START --------------------------

  /**
   * 发起linkedin授权
   * @param param
   * @returns {Promise<DefaultResponseType>}
   */
  linkedinAuthorize(param) {
    return axios_("get", `api/pandagpt/v1/linkedin/get_authorization_url`, param, false, false, true, false);
  },
  /**
   * Linkedin平台账号授权回调
   * @param {null} param
   * @returns {Promise<DefaultResponseType>}
   */
  getLinkedinAuthCallback(param) {
    return axios_("POST", `api/pandagpt/v1/linkedin/callback`, param, false, false, true, false);
  },

  // #endregion -------------------------- linkedin END ----------------------------

  /**
   * 根据 osskey 获取文件的临时链接
   * @param {string} osskey
   * @return {Promise<DefaultResponseType>}
   */
  getUrlByOsskey(osskey) {
    return usePyRequest("GET", "api/pandagpt/v1/aliyun_oss/get_signed_url", {osskey});
  }
};
